import React, { useState } from 'react';
import { Layout, Menu, Button, theme } from 'antd';
import { 
  MenuUnfoldOutlined, 
  MenuFoldOutlined, 
  DashboardOutlined, 
  SettingOutlined, 
  PictureOutlined, 
  TeamOutlined, 
  ShoppingOutlined,
  LogoutOutlined,
  AppstoreOutlined,
  EditOutlined,
  UserOutlined
} from '@ant-design/icons';
import { Outlet, useNavigate, useLocation, Link } from 'react-router-dom';

const { Header, Sider, Content } = Layout;

const AdminLayout = ({ onLogout }) => {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const menuItems = [   
    {
      key: 'websitesettings',
      icon: <SettingOutlined />,
      label: 'Website Settings',
      onClick: () => navigate('/admin/websitesettings')
    }, 
    {
      key: 'settings',
      icon: <SettingOutlined />,
      label: 'Logo and Slider',
      onClick: () => navigate('/admin/settings')
    },    
    {
      key: 'edit-about-us',
      icon: <EditOutlined />,
      label: 'Edit Page Details',
      onClick: () => navigate('/admin/edit-about-us')
    },
    {
      key: 'clients',
      icon: <TeamOutlined />,
      label: 'Clients',
      onClick: () => navigate('/admin/clients')
    },    
    {
      key: 'categories',
      icon: <AppstoreOutlined />,
      label: <Link to="/categories">Categories</Link>,
      onClick: () => navigate('/admin/categories')
    },
    {
      key: 'products',
      icon: <ShoppingOutlined />,
      label: 'Products',
      onClick: () => navigate('/admin/products')
    },
    {
      key: 'users',
      icon: <UserOutlined />,
      label: 'Users',
      onClick: () => navigate('/admin/users')
    }
    
  ];

  // Extract the current selected key from the URL
  const selectedKey = location.pathname.split('/')[2] || 'dashboard';

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider trigger={null} collapsible collapsed={collapsed}>
        <div className="logo" style={{ height: 32, margin: 16, background: 'rgba(255, 255, 255, 0.2)' }} />
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[selectedKey]}
          items={menuItems}
        />
      </Sider>
      <Layout>
        <Header style={{ padding: 0, background: colorBgContainer }}>
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            style={{
              fontSize: '16px',
              width: 64,
              height: 64,
            }}
          />
          <Button 
            type="text" 
            icon={<LogoutOutlined />} 
            onClick={onLogout}
            style={{ float: 'right', margin: '16px 24px' }}
          >
            Logout
          </Button>
        </Header>
        <Content
          style={{
            margin: '24px 16px',
            padding: 24,
            background: colorBgContainer,
            borderRadius: borderRadiusLG,
          }}
        >
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default AdminLayout; 